/**
 * What every signed-in screen needs from the start: the host's brand and the current
 * sub-account's plan. Kept apart from the module tables (lazy-api.ts) so the shell's first
 * requests do not wait for any of them.
 */
import type { PublicBranding, SubaccountBilling } from '@schemas/rebilling';
import type { ApiClient } from './client';

/** Public: the brand for this host, or for a public page (pay link token, booking page slug) */
export function brandingApi(client: ApiClient) {
  return {
    get: (page: { pay?: string; booking?: string; portal?: string } = {}) =>
      client.request<PublicBranding>('GET', '/branding', { query: { pay: page.pay, booking: page.booking, portal: page.portal }, auth: false }),
  };
}

export function sessionApi(client: ApiClient) {
  return {
    /** The current sub-account's plan, usage and invoices (the shell reads which modules the plan turns on) */
    plan: () => client.request<SubaccountBilling>('GET', '/billing/subaccount'),
  };
}

export type BrandingApi = ReturnType<typeof brandingApi>;
export type SessionApi = ReturnType<typeof sessionApi>;
